import React from 'react';
import AOS from 'aos';
import { withPrefix } from 'gatsby-link';
import Helmet from 'react-helmet';

import Banner from '../../components/Banner';

import './_white-labelling.scss';

class WhiteLabellingPage extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {

    return (
      <div className="white-labelling-page">
        <Helmet>
          <title>White Label | FirstStep</title>
          <meta name="description" content="Bring your investment app to life" />
        </Helmet>
        <Banner
          ctaMode={true}
          buttonMode={false}
          contactLink="hello@firststep.co"
          title="Bring your investment product to life"
          tagline="For enquiries, please contact"
        />

        <section className="app-screen invest" data-aos="fade-up" data-aos-once>
          <div className="wrapper">
            <div className="inner-wrapper">
              <div className="row align-items-center">
                <div className="col-md-6 content">
                  <div className="section-left">
                    <h2>White label FirstStep and launch</h2>

                    {/* <p>Our vision is for every person to save towards a secure financial future without compromising a fulfilling life today. </p> */}

                    <p>Our mission is to create a micro-investment solution that helps people reach their goals faster in a simple and engaging way. This mission is delivered through the FirstStep brand and white label partners.</p>

                    <p>To pass on low fees to its customers, FirstStep made a bold decision to build its own operating system, one that can seamlessly be integrated with other products.</p>

                    <p>FirstStepOS is a proven micro-investing platform that helps build and run an entire managed investment scheme (MIS) whose distinct personalised touch gives you a distinct competitive advantage. </p>

                    {/* <p>Our goal is to empower every young person to save and secure their financial future while enjoying their everyday lives. We believe that your customers should enjoy their present, while planning for their future in a smart way.</p> */}
                    {/* <p>Our aim is to provide banks and other financial institutions with a secure and compliant, white-label micro-investment solution that helps your customers to reach their goals faster in an engaging way.</p> */}
                    {/* <p>Your business can leverage FirstStep as a technology provider to bring a white label investment app to market.</p> */}
                  </div>
                </div>
                <div className="col-md-6 phone">
                  <div className="section-right text-right">
                    <img src={withPrefix('images/graphics/app-screens/iphone_sectors.png')} className="iphone-img img-fluid w-75" alt="Phone screen sectors"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="container">

          {/* <div class="card card-banner mx-4">
            <div class="card-body">
              <p class="card-text">Genius technology continues to redefine every relationship we manage in our busy lives including how, where, why, what and when we save. And it just got smarter, safer, and easier with a savvy new platform that offers great returns, lower fees and peace of mind.</p>
              <p class="card-text">Start a very powerful and personal savings crusade today. Save with FirstStep and you will always be one step ahead.</p>
            </div>
          </div> */}

          {/* <section class="content-block text-center">
            <div class="row">
              <div class="col-12">
                <h2>Adding value for your business</h2>
                <p></p>
                <p></p>
              </div>
            </div>
          </section> */}

        </div>

          <section class="what-get" data-aos="fade-up" data-aos-once>
            <div class="wrapper">
              <div class="inner-wrapper">
                <h2 class="text-center">Adding value for your business</h2>
                <div class="row">
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Lower acquisition costs</h4>
                        <p>Investing apps have a lower cost of acquisition with greater loyalty</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Engagement with millennials</h4>
                        <p>Build direct engagement with millennials early in their financial journey</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Bank aggregation and payments</h4>
                        <p>Data feeds, fast cash transfers and cash reconiliation at scale</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Goals based investing</h4>
                        <p>Invest with passion and purpose by setting goals and tracking progress</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Unit registry</h4>
                        <p>Onboard customers at scale with instant verification and ongoing due diligence</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-tick.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Fund administration</h4>
                        <p>Automated investment management services so you can spend more time with customers</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

      </div>
    );
  }
}

export default WhiteLabellingPage;



// WEBPACK FOOTER //
// ./src/pages/white-labelling/index.js